import { html } from 'rune-ts';
import klass from './ReceiptViewer.module.scss';
import { font } from '../../../shared/typography';
import { ButtonAction } from '../../../shared/components/atoms/ButtonAction/ButtonAction';

export const makeTopSectionHtml = (title: string, pdf_button_label: string, print_button_label: string) => {
  return html`
    <section class="${klass.section_top}">
      <span class="${font('20_bold')}">${title}</span>
      <div class="${klass.buttons}">
        ${new ButtonAction({
          klass: klass.button_pdf,
          fit: true,
          size: 'large',
          label: pdf_button_label,
          type: 'line',
        })}
        ${new ButtonAction({
          klass: klass.button_print,
          fit: true,
          size: 'large',
          label: print_button_label,
          type: 'blue',
        })}
      </div>
    </section>
  `;
};
